import Equipment from '../../models/Equipment';
import { ROUTES } from '../../../../config/routes';
import translations from './locales';

const xe20 = new Equipment({
  id: 'xe20',
  name: 'XE20/26',
  displayName: { main: 'XE20/26' },
  path: ROUTES.xe20Intro,
  assetDirectory: '/Equipment/xe20',
  translations,
  image: { file: 'machine.png', width: 1536, height: 1024 },
  video: null,
  catalog: {
    fallbackLanguage: 'en',
    files: { ko: 'catalog.png', en: 'catalog-en.png', zh: 'catalog-zh.png' },
  },
  badges: [
    { id: 'diameter', valueKey: 'diameterTag' },
    { id: 'spindle', value: '10,000 / 8,000 rpm' },
  ],
  metrics: [
    { id: 'diameter', labelKey: 'specifications.maxDiameter.label', value: 'Ø20 / Ø26', unit: 'mm' },
    { id: 'spindle', labelKey: 'specifications.mainSpindle.label', value: '10,000 / 8,000', unit: 'rpm' },
    { id: 'stroke', labelKey: 'hStroke', value: '210', unit: 'mm' },
    { id: 'cross', labelKey: 'specifications.crossTools.label', value: '4', unit: 'ER16' },
  ],
  features: ['configuration', 'crossTools', 'backTools'],
  specifications: [
    { id: 'nc', value: 'Fanuc 0i-TF Plus' },
    { id: 'maxDiameter', value: 'XE20: Ø20 mm / XE26: Ø26 mm' },
    { id: 'z1Stroke' },
    { id: 'mainSpindle', value: 'XE20: 10,000 rpm · 2.2 / 3.7 kW / XE26: 8,000 rpm · 2.2 / 5.5 kW' },
    { id: 'turningTools', value: 'XE20: 6 × (□12 mm) / XE26: 5 × (□16 mm)' },
    { id: 'frontTools', value: '5 × (ER16M, Ø25)' },
    { id: 'crossTools', value: '4 × (ER16)' },
    { id: 'crossSpeed', value: '6,000 rpm / 1.0 kW' },
    { id: 'offCenterTools', value: '2 × (ER16)' },
    { id: 'subSpindle', value: '8,000 rpm · 1.5 / 2.2 kW' },
    { id: 'backTools' },
    { id: 'backSpeed', value: '6,000 rpm / 1.0 kW' },
    { id: 'dimensions', value: '2,260 × 1,240 × 1,670 mm' },
    { id: 'weight', value: '2,500 kg' },
    { id: 'power' },
    { id: 'air', value: '120–150 L/min' },
  ],
  specificationNoteKey: 'specificationNote',
  options: ['crossFive', 'crossSix', 'offCenter', 'faceTools'],
  optionImages: {
    crossFive: 'crossFive.jpg',
    crossSix: 'crossSix.jpg',
  },
});

export default xe20;
